import './showData.scss';
import './showData.override.scss';

import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { fromJS } from 'immutable';
import { recordProcess } from 'utilities/tagging';
import { i18n } from 'core/i18n';
import OKModal from 'components/commons/OKModal/OKModal';
import { OKButton } from 'components/commons/OKButton/OKButton';
import OKInformativeList from 'components/rebrand/OKInformativeList/OKInformativeList';
import OKInformativeListItem from 'components/rebrand/OKInformativeListItem/OKInformativeListItem';
import Highlighted from 'components/commons/highlighted/highlighted';
import ContactCenterRender from 'components/conditionalRender/contactCenterRender';
import WebappRender from 'components/conditionalRender/webappRender';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { OKLink } from 'commonsComponents/OKLink';
import {
  getFormattedShippingAddressExt,
  getFormattedShippingAddress,
} from 'utilities/personalDataHelper';
import BlockInfo from 'components/contactCenter/blockInfo/blockInfo';
import TaxAdditionalCountryData from 'components/myProfile/taxAdditionalCountryList/taxAdditionalCountryData';
import { CODE_ADDRESS_EXT } from 'constants/index';
import myProfileEditor from 'constants/myProfileEditor';
const {
  PROFILE_EDIT_FORMS: {
    ADDRESS,
    EMAIL,
    EMAIL_CONTACT_TIME,
    FISCAL_DATA,
    PHONE,
    PHONE_CONTACT_TIME,
    SHIPPING_ADDRESS,
  },
} = myProfileEditor;
import { SHIPPING_ADDRESS_USER } from 'constants/flagBasedFeatures.js';
import { mobilePhoneCodes } from 'constants/contactCenter/modifyMainPhone';
import { PROC_DELETE_SHIPPING_ADDRESS, PROC_START } from 'utilities/tagging';

const { formatText, FormattedText } = i18n;

const FIOC_URLS = {
  DOCUMENTATION_FORM: '/myprofile/edit/fioc',
  PERSONAL_INFO_FORM: '/myprofile/fioc',
};

class ShowData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteShippingAddressModalOpen: false,
    };
  }

  componentDidMount() {
    const locationHash = this.props.history.location.hash;

    if (locationHash) {
      const infoSectionElement = document.querySelector(locationHash);
      this.scrollToElement(infoSectionElement);
    }
  }

  scrollToElement = element => {
    if (element) {
      let topbarHeight = 0;
      const topbarElement = document.querySelector(__CONTACT_CENTER__ ? '.ok-tabs' : '.ok-topbar');
      const rect = element.getBoundingClientRect();

      if (topbarElement) {
        topbarHeight = topbarElement.offsetHeight || 0;
      }

      const scrollTop = (window.pageYOffset || document.documentElement.scrollTop) - topbarHeight;

      window.scrollTo({
        top: rect.top + scrollTop,
        behavior: 'smooth',
      });
    }
  };

  getUTagCustomTagDataForFioc(eventTag) {
    // does not require translation
    return {
      eventCategory: 'actualizacion fioc',
      eventName: 'inicio',
      eventTag,
    };
  }

  applyHighlightToObj() {
    const {
      step,
      listCountries: { immCountries },
    } = this.props;
    const { listPaisesTributacionAdicInitial } = step.toJS();

    const highlightAppplied = immCountries.toJS().map(pais => {
      pais.highlight = {};

      if (pais.id >= 0) {
        const initialValues = listPaisesTributacionAdicInitial.find(
          paisInitial => paisInitial.id === pais.id
        );
        pais.highlight = {
          paisTributacion: pais.paisTributacion.trim() !== initialValues.paisTributacion.trim(),
          indTipoTributacion:
            pais.indTipoTributacion.trim() !== initialValues.indTipoTributacion.trim(),
          codigodocumpersonacorp:
            pais.tin.codigodocumpersonacorp.trim() !==
            initialValues.tin.codigodocumpersonacorp.trim(),
        };
      } else {
        pais.highlight = {
          indTipoTributacion: true,
          paisTributacion: true,
          codigodocumpersonacorp: true,
        };
      }
      return pais;
    });
    return fromJS(highlightAppplied);
  }

  buildListCountriesWithAdditionalTaxing() {
    const { immCountries, dirty } = this.props.listCountries;
    const listCountriesAdditionalTaxing = this.props.step
      ? this.applyHighlightToObj()
      : immCountries;
    let content;
    if (listCountriesAdditionalTaxing && listCountriesAdditionalTaxing.size === 0) {
      content = (
        <FormattedText
          className="ok-informative-list-item__body-text"
          value="profile-taxInformation_noAdditionalTributation"
        />
      );

      if (this.props.step && this.props.step.get('listPaisesTributacionAdicInitial').size) {
        content = <Highlighted isHighlighted={dirty}>{content}</Highlighted>;
      }
    } else {
      content = listCountriesAdditionalTaxing.map((item, index) => (
        <div className="ok-informative-list-item__body-text" key={index}>
          <TaxAdditionalCountryData immCountry={item} />
        </div>
      ));
    }

    return content;
  }

  buildDataFromGroup(title, dataGroup, titleButton, tooltipOffset, tooltipContent, elementId) {
    return (
      <OKInformativeList
        columns={2}
        title={title}
        titleButton={titleButton}
        tooltipOffset={tooltipOffset}
        information={tooltipContent}
        icon={!!tooltipContent}
        elementId={elementId}
      >
        {dataGroup.map((data, index) => {
          const element = (
            <OKInformativeListItem
              className={data.className}
              deleteButton={data.deleteButton}
              editButton={data.editButton}
              icon={!!data.tooltipContent}
              information={formatText(data.tooltipContent)}
              key={index}
              title={formatText(data.title)}
              tooltipOffset={data.tooltipOffset}
            >
              {data.value}
            </OKInformativeListItem>
          );

          return data.visible ? element : null;
        })}
      </OKInformativeList>
    );
  }

  buildEditButton(formToLoad) {
    const { canEdit, immProfileShippingAddress } = this.props;
    const classButton =
      formToLoad === FISCAL_DATA
        ? 'show-data__update-button--fiscal-data'
        : 'show-data__update-button';

    let editButton = (
      <span className={classButton}>
        <OKButton
          isOKButtonOld={true} //TODO this button should be changed to an action
          modifier="tasks-light-small"
          onClick={() => this.handleEditButtonClick(formToLoad)}
          disabled={canEdit}
          loaderColor="dark"
          loaderSize="small"
        >
          <i className="icon-editar" />
        </OKButton>
      </span>
    );

    if (formToLoad === SHIPPING_ADDRESS && !immProfileShippingAddress.get('hasShippingAddress')) {
      editButton = null;
    }

    return editButton;
  }

  buildDeleteButton(formToLoad) {
    const { canEdit } = this.props;

    return (
      <span className="show-data__delete-button">
        <OKButton
          isOKButtonOld={true} //TODO this button should be changed to an action
          modifier="tasks-light-small"
          onClick={() => this.handleDeleteButtonClick(formToLoad)}
          disabled={canEdit}
          loaderColor="dark"
          loaderSize="small"
        >
          <i className="icon-eliminar" />
        </OKButton>
      </span>
    );
  }

  createUpdateLink(destination) {
    return (
      <OKButton
        modifier="link-emphasize"
        autoHeight={true}
        onClick={() => this.handleUpdateFiocClick(destination)}
      >
        <FormattedText value="fiocSection-update" />
      </OKButton>
    );
  }

  handleEditButtonClick(formToLoad) {
    if (__CONTACT_CENTER__ && formToLoad === PHONE_CONTACT_TIME) {
      this.props.history.push(`/myprofile/edit/update-client-contact-time/${PHONE_CONTACT_TIME}`);
    } else if (__CONTACT_CENTER__ && formToLoad === EMAIL_CONTACT_TIME) {
      this.props.history.push(`/myprofile/edit/update-client-contact-time/${EMAIL_CONTACT_TIME}`);
    } else if (formToLoad === SHIPPING_ADDRESS) {
      this.props.history.push('/myprofile/edit/shipping-address/update');
    } else {
      this.props.setEditMode(formToLoad);
    }
  }

  handleOnAcceptDeleteShippingAddress = () => {
    this.setState({
      deleteShippingAddressModalOpen: false,
    });

    this.props.history.push('/myprofile/edit/shipping-address/remove');
  };

  handleOnCancelDeleteShippingAddress = () => {
    this.setState({
      deleteShippingAddressModalOpen: false,
    });
  };

  handleDeleteButtonClick(formToLoad) {
    if (formToLoad === SHIPPING_ADDRESS) {
      if (__CONTACT_CENTER__) {
        this.props.history.push('/myprofile/edit/shipping-address/remove');
      }
      recordProcess(PROC_DELETE_SHIPPING_ADDRESS, PROC_START);

      this.setState({
        deleteShippingAddressModalOpen: true,
      });
    }
  }

  handleUpdateFiocClick(destination) {
    // does not require translation
    const uTagEvents = {
      [FIOC_URLS.DOCUMENTATION_FORM]: 'subir documentacion',
      [FIOC_URLS.PERSONAL_INFO_FORM]: 'actualizar fioc',
    };
    recordProcess(
      'actualizacion fioc',
      null,
      this.getUTagCustomTagDataForFioc(uTagEvents[destination])
    );
    this.props.history.push(destination);
  }

  buildPhonesData() {
    const { phonesList } = this.props;

    const secondaryPhones = phonesList.filter(phone => {
      return phone.preferente === 'N';
    });

    return secondaryPhones.map((phone, index) => {
      let title;

      if (mobilePhoneCodes.includes(phone.tipoUso)) {
        title =
          secondaryPhones.length === 1
            ? 'personalData-mobilePhoneLabel'
            : `personalData-mobilePhoneLabel${index}`;
      } else {
        title =
          secondaryPhones.length === 1
            ? 'personalData-landLinePhoneLabel'
            : `personalData-landlinePhoneLabel${index}`;
      }

      return {
        title,
        visible: true,
        value: phone.detalleContacto,
      };
    });
  }

  buildContactDataObject(previousGroupDataObject) {
    if (__CONTACT_CENTER__) {
      const secondaryPhonesData = this.buildPhonesData();
      const { fromEmailContactTime, toEmailContactTime, fromPhoneContactTime, toPhoneContactTime } =
        this.props;
      const groupDataCC = [
        {
          title: 'personalData-contactTime_phone',
          visible: true,
          value: formatText('personalData-contactTime_text', [
            fromPhoneContactTime,
            toPhoneContactTime,
          ]),
          editButton: this.buildEditButton(PHONE_CONTACT_TIME),
        },
        {
          title: 'personalData-contactTime_email',
          visible: true,
          value: formatText('personalData-contactTime_text', [
            fromEmailContactTime,
            toEmailContactTime,
          ]),
          editButton: this.buildEditButton(EMAIL_CONTACT_TIME),
        },
      ];
      return [...previousGroupDataObject, ...groupDataCC, ...secondaryPhonesData];
    }
    return previousGroupDataObject;
  }

  secondaryMobilePhones() {
    const { phonesList } = this.props;
    const mobilePhonesTypes = ['04', '05'];
    return phonesList.filter(phone => {
      return mobilePhonesTypes.includes(phone.tipoUso) && phone.preferente === 'N';
    });
  }

  buildMainPhoneModificationLink() {
    const secondaryMobilePhones = this.secondaryMobilePhones();

    let link = null;
    if (__CONTACT_CENTER__ && secondaryMobilePhones.length > 0) {
      link = (
        <OKLink
          extraClass="show-data__modify-main-phone-link"
          to="/myprofile/edit/update-main-phone"
        >
          <FormattedText value="profile-modifyMainPhoneNumberLabel" />
        </OKLink>
      );
    }
    return link;
  }

  buildShippingAddressDisclaimerCC(shippingAddressData) {
    const { fullName } = this.props;

    let disclaimer;

    if (__CONTACT_CENTER__) {
      if (shippingAddressData.showAddShippingAddressAction) {
        disclaimer = (
          <div className="show-data__disclaimer">
            <BlockInfo extraClass="show-data__block-info">
              <p>
                <FormattedText value="cc_profileEditShippingAddress-profileEditShippingAddress_srOrSra" />{' '}
                <b>{fullName}</b>
              </p>
              <p>
                <FormattedText value="cc_profileEditShippingAddress-profileEditShippingAddress_newShippingDisclaimer" />
              </p>
            </BlockInfo>
          </div>
        );
      } else if (shippingAddressData.showEditShippingAddressAction) {
        disclaimer = (
          <div className="show-data__disclaimer">
            <BlockInfo extraClass="show-data__block-info">
              <p>
                <FormattedText value="cc_profileEditShippingAddress-profileEditShippingAddress_editShippingDisclaimer" />
              </p>
            </BlockInfo>
          </div>
        );
      }
    }

    return disclaimer;
  }

  getShippingAddressData() {
    const { flagBasedFeatures, immProfileShippingAddress } = this.props;

    let retObj = {
      shippingAddress: '',
      showAddShippingAddressActionAction: false,
      showEditShippingAddressAction: flagBasedFeatures.get('profile-shipping-address-edit-enabled'),
      showRemoveShippingAddressAction: false,
      showShippingAddress: true,
    };

    if (immProfileShippingAddress.get('fetchSuccess')) {
      if (immProfileShippingAddress.get('hasShippingAddress')) {
        if (immProfileShippingAddress.get('codFormatoDomicilio') === CODE_ADDRESS_EXT) {
          retObj.shippingAddress = getFormattedShippingAddressExt(
            immProfileShippingAddress.get('shippingAddressExt').toJS()
          );
        } else {
          retObj.shippingAddress = getFormattedShippingAddress(
            immProfileShippingAddress.get('shippingAddress').toJS()
          );
        }
        retObj.showRemoveShippingAddressAction = flagBasedFeatures.get(
          'profile-shipping-address-remove-enabled'
        );
      } else if (flagBasedFeatures.get('profile-shipping-address-add-enabled')) {
        retObj.showAddShippingAddressAction = true;
        retObj.shippingAddress = (
          <OKLink modifier="complementary" to="/myprofile/edit/shipping-address/add">
            <FormattedText value="profileEditShippingAddress-profileEditShippingAddress_newAddress" />
          </OKLink>
        );
      } else {
        retObj.showShippingAddress = false;
      }
    } else if (immProfileShippingAddress.get('isFetching')) {
      retObj.shippingAddress = (
        <div className="show-data__loading-section">
          <LoadingSection />
        </div>
      );
    } else {
      retObj.showShippingAddress = false;
    }

    return retObj;
  }

  render() {
    const {
      address,
      birthCountry,
      birthProvince,
      birthSquare,
      email,
      fullPhoneNumber,
      fiocDocumentation,
      flagBasedFeatures,
    } = this.props;
    const tooltip = {
      icon: 'show-data__fioc-tooltip-icon',
      tooltipPlacement: 'topLeft',
      tooltipClassName: 'fioc-upload-document-view__tooltip',
      tooltipOffset: [-45, -10],
    };
    const tooltipInfo = ['fiocSection-titleTooltip', 'fiocSection-activityTooltip'];
    const shippingAddressData = this.getShippingAddressData();
    const shippingAddressDisclaimerCC = this.buildShippingAddressDisclaimerCC(shippingAddressData);

    let documentationValue = formatText('fiocSection-updated');
    let fiocValue = formatText('fiocSection-updated');

    const fatcaValue =
      fiocDocumentation.get('codMessage') == '10' &&
      !fiocDocumentation.get('fiocRequested') &&
      fiocDocumentation.get('documentationRequested') &&
      fiocDocumentation.get('fiocStatus') === 0 &&
      fiocDocumentation
        .get('documentList')
        .toJS()
        .filter(d => d.codTipoDocumento == '30').length ? (
        <OKLink modifier="emphasize" to="/myprofile/fatca">
          {formatText('fatcaSection-link')}
        </OKLink>
      ) : (
        formatText('fatcaSection-updated')
      );

    if (fiocDocumentation.get('isStatusFetching')) {
      documentationValue = (
        <div className="show-data__loading-section">
          <LoadingSection />
        </div>
      );
      fiocValue = (
        <div className="show-data__loading-section">
          <LoadingSection />
        </div>
      );
    } else if (!fiocDocumentation.get('statusError') && fiocDocumentation.get('fiocStatus') !== 0) {
      if (fiocDocumentation.get('documentationRequested')) {
        documentationValue = this.createUpdateLink(FIOC_URLS.DOCUMENTATION_FORM);
      } else if (!fiocDocumentation.get('fiocRequested')) {
        documentationValue = formatText('fiocSection-statusRV');
      }
      if (fiocDocumentation.get('fiocRequested')) {
        fiocValue = this.createUpdateLink(FIOC_URLS.PERSONAL_INFO_FORM);
      }
    }

    const groupData01 = [
      {
        title: 'profile-contactData_phone',
        visible: true,
        value: fullPhoneNumber,
        editButton: this.buildEditButton(PHONE),
      },
      {
        title: 'profile-contactData_email',
        visible: true,
        value: email,
        editButton: this.buildEditButton(EMAIL),
      },
    ];

    const groupData02 = [
      {
        title: 'profile-contactData_address',
        visible: true,
        value: address,
        editButton: this.buildEditButton(ADDRESS),
      },
      flagBasedFeatures.get(SHIPPING_ADDRESS_USER) && {
        className: 'ok-informative-list-item__with-tooltip',
        deleteButton:
          shippingAddressData.showRemoveShippingAddressAction &&
          this.buildDeleteButton(SHIPPING_ADDRESS),
        editButton:
          shippingAddressData.showEditShippingAddressAction &&
          this.buildEditButton(SHIPPING_ADDRESS),
        title: 'profileEditShippingAddress-profileEditShippingAddress_shippingAddress',
        tooltipContent: 'profileEditShippingAddress-profileEditShippingAddress_tooltip',
        tooltipOffset: [15, -6],
        value: shippingAddressData.shippingAddress,
        visible: shippingAddressData.showShippingAddress,
      },
    ];

    const groupData03 = [
      {
        title: 'profile-birthCountry',
        visible: true,
        value: birthCountry,
      },
      {
        title: 'profile-taxInformation_birthLocality',
        visible: true,
        value: birthSquare,
      },
      {
        title: 'profile-taxInformation_birthProvince',
        visible: Boolean(birthProvince),
        value: birthProvince,
      },
      {
        title: 'profile-taxInformation_CountriesAdditionalTributationTitle',
        visible: true,
        value: this.buildListCountriesWithAdditionalTaxing(),
      },
    ];

    const groupData04 = [
      {
        title: 'fiocSection-activity',
        visible: true,
        value: fiocValue,
        tooltip,
        tooltipContent: tooltipInfo[1],
      },
      {
        title: 'fiocSection-documentation',
        visible: true,
        value: documentationValue,
      },
    ];

    const groupData05 = [
      {
        title: 'fatcaSection-activity',
        visible: true,
        value: fatcaValue,
      },
    ];

    const groupData01Built = this.buildDataFromGroup(
      'profile-contactData_title',
      this.buildContactDataObject(groupData01),
      null,
      null,
      null,
      'contactData'
    );
    const groupData02Built = this.buildDataFromGroup(
      'profile-addressData_title',
      groupData02,
      null,
      null,
      null,
      'contactAddress'
    );
    const groupData03Built =
      __CONTACT_CENTER__ &&
      this.buildDataFromGroup(
        'profile-taxInformation_title',
        groupData03,
        this.buildEditButton(FISCAL_DATA),
        null,
        null,
        'taxInfo'
      );
    const groupData04Built = this.buildDataFromGroup(
      'fiocSection-title',
      groupData04,
      null,
      tooltip,
      tooltipInfo[0],
      'fioc'
    );
    const groupData05Built =
      __CONTACT_CENTER__ &&
      this.buildDataFromGroup(
        'fatcaSection-title',
        groupData05,
        null,
        tooltip,
        'fatcaSection-titleTooltip',
        'fat'
      );
    const phoneModificationLink = __CONTACT_CENTER__ && this.buildMainPhoneModificationLink();

    return (
      <div className="show-data">
        {groupData01Built}
        <ContactCenterRender>{phoneModificationLink}</ContactCenterRender>
        {groupData02Built}
        {shippingAddressDisclaimerCC}
        <ContactCenterRender>{groupData03Built}</ContactCenterRender>

        {groupData04Built}

        <ContactCenterRender>{groupData05Built}</ContactCenterRender>
        <WebappRender>
          <OKModal
            description="profileEditShippingAddress-profileEditShippingAddress_deleteShippingAddressModalBody"
            descriptionAlignment="center"
            footerType="action"
            isOpen={this.state.deleteShippingAddressModalOpen}
            onCloseCallback={() => this.handleOnCancelDeleteShippingAddress()}
            onPrimaryButtonClick={() => this.handleOnAcceptDeleteShippingAddress()}
            onSecondaryButtonClick={() => this.handleOnCancelDeleteShippingAddress()}
            primaryButtonText={formatText(
              'profileEditShippingAddress-profileEditShippingAddress_continue'
            )}
            secondaryButtonText={formatText(
              'profileEditShippingAddress-profileEditShippingAddress_back'
            )}
            shouldCloseOnOverlayClick={false}
            title="profileEditShippingAddress-profileEditShippingAddress_deleteShippingAddressModalTitle"
            titleAlignment="center"
          />
        </WebappRender>
      </div>
    );
  }
}

ShowData.propTypes = {
  address: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  birthCountry: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  birthProvince: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  birthSquare: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  canEdit: PropTypes.bool.isRequired,
  email: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  fiocDocumentation: PropTypes.object,
  flagBasedFeatures: PropTypes.object.isRequired,
  fromEmailContactTime: PropTypes.string,
  fromPhoneContactTime: PropTypes.string,
  fullName: PropTypes.string.isRequired,
  fullPhoneNumber: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  history: PropTypes.object.isRequired,
  immProfileShippingAddress: PropTypes.object.isRequired,
  listCountries: PropTypes.object,
  phonesList: PropTypes.arrayOf(PropTypes.object),
  setEditMode: PropTypes.func,
  shippingAddress: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  step: PropTypes.object,
  toEmailContactTime: PropTypes.string,
  toPhoneContactTime: PropTypes.string,
};

export default withRouter(ShowData);
